export const allowOnlyAlphabets = (e) => {
  if (!/^[a-zA-Z\s]*$/.test(e.data)) {
    e.preventDefault();
  }
};

export const allowOnlyNumbers = (e) => {
   if (!/^[0-9]*$/.test(e.data)) {
    e.preventDefault();
  }  
}

export const amountRegex = (e) => {
    if(!/^[0-9.,]*$/.test(e.data))
    {
        e.preventDefault();
    }
}

export const validateIndianAmount = (value) => {
  const regex = /^(\d{1,3})(,\d{2})*(\.\d{1,2})?$|^\d+(\.\d{1,2})?$/;
  return regex.test(value);
};